export enum OfficeInformationView {
  OfficeInformation, DeskBooking, CarParkBooking, MeetingRooms, Hospitality, AutomaticCheckin
}


export enum OfficeManagementPanelView {
  OfficeManagement, DeskManagement, AreaManagement,
}
